<template>
  <div class="prognostic">
    <div class="row justify-content-md-center" style="margin-top: 10px;">
      <div v-if="prognostic" class="col-lg-4 col-12">
        <b-img :src="'../img/'+prognostic.type+'.jpg'" thumbnail fluid :alt="prognostic.type"></b-img>
      </div>
    </div>
    <div class="row justify-content-md-center" style="margin-top: 10px;">
      <div v-if="prognostic" class="col-lg-6 col-12">
        <b-jumbotron bg-variant="dark" text-variant="white" border-variant="white">
          <template slot="lead">
            <small>
              <div class="float-right">
                <b-badge pill variant="warning" class="d-block" style="margin-bottom: 2px;" v-if="prognostic.date >= vip_timestamp">Pronostic VIP</b-badge>
                <b-badge pill variant="secondary" class="d-block" style="margin-bottom: 2px;" v-if="prognostic.type">{{ prognostic.type.toUpperCase() }}</b-badge>
                <b-badge pill variant="success" class="d-block" style="margin-bottom: 2px;" v-if="prognostic.win === true">GAGNANT</b-badge>
                <b-badge pill variant="danger" class="d-block" style="margin-bottom: 2px;" v-if="prognostic.win === false">PERDANT</b-badge>
              </div>
            </small>
            
          </template>
          <template slot="lead" >
            <h2 class="text-uppercase text-warning">
              {{ prognostic.title + (prognostic.cote ? ' - COTE à ' + prognostic.cote : '')  }}
            </h2>
            <small class="font-italic text-muted">du {{ moment(prognostic.date).format('dddd Do MMMM YYYY') }}</small>
            <hr class="my-4">
            <span v-if="prognostic.text" v-html="prognostic.text.split('\n').join('<br/>')"></span>
          </template>
          <hr class="my-4" v-if="prognostic.details">
          <p v-if="prognostic.details" v-html="prognostic.details.split('\n').join('<br/>')"></p>
        </b-jumbotron>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { db } from '@/firebase.js'

export default {
  data: () => ({ prognostic: null, vip_timestamp: moment().startOf('day').unix() }),
  methods: {
    moment(ts) { return ts ? moment.unix(ts) : moment() }
  },
  watch: {
    '$route': {
      immediate: true,
      handler(route) {
        this.$bind('prognostic', db.collection('prognostics').doc(route.params.id))
      },
    },
  }
}
</script>
